// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__14c55","title":"FrontImage_title__25xIx"};